
define('jst!podio_picker/input_token',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class="image-block">\n\n  <div class="img">\n    <div class="icon-16 <%= icon %>"></div>\n  </div>\n  <div class="bd input-box">\n    <label><%= placeholderText %></label>\n  </div>\n</div>\n\n');
 });

